import React, {Component} from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';

import AuthenticatePinterest from './pinterest';

const RENDER_STRATEGIES = {
    pinterest: AuthenticatePinterest
};

export default class AuthenticatePlatform extends Component {
    static propTypes = {
        platform: PropTypes.string.isRequired,
        auth_urls: PropTypes.objectOf(PropTypes.string)
    };

    getAuthUrlForPlatform = () => {
        const {platform, auth_urls: authUrls} = this.props;

        return R.prop(platform, authUrls);
    };

    render() {
        const {platform} = this.props;

        const AuthenticateView = R.propOr(null, platform, RENDER_STRATEGIES);

        return <AuthenticateView authUrl={this.getAuthUrlForPlatform()} {...this.props} />;
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_info/components/views/authenticate/index.js